import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AppRole, AuthService, PermissionModule } from './auth.service';

export function roleGuard(minimumRole?: AppRole): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (!auth.isAuthenticated()) {
      return router.createUrlTree(['/login']);
    }

    if (!minimumRole) return true;

    const checkRole = () => auth.hasRole(minimumRole) || router.createUrlTree(['/incidents']);

    if (!auth.currentUser()) {
      return auth.getAuthUserData().pipe(
        map(() => checkRole()),
        catchError(() => of(router.createUrlTree(['/login']))),
      );
    }

    return checkRole();
  };
}

export const authGuard = roleGuard();

/** Blocks the route unless the user has any non-None permission on the module. */
export function moduleGuard(module: PermissionModule): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (!auth.isAuthenticated()) {
      return router.createUrlTree(['/login']);
    }

    const checkModule = () => auth.hasModuleAccess(module) || router.createUrlTree(['/incidents']);

    if (!auth.currentUser()) {
      return auth.getAuthUserData().pipe(
        map(() => checkModule()),
        catchError(() => of(router.createUrlTree(['/login']))),
      );
    }

    return checkModule();
  };
}

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.isAuthenticated() ? router.createUrlTree(['/incidents']) : true;
};
